import { PacingStatusTable } from './PacingStatusTable/PacingStatusTable';

import './entityPacingStatus.scss';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import type { ComposedEntityPacing, EntityPacing } from './PacingStatusTable/PacingStatusTable';

type Props = {
  currencyInfo: BaseCurrencyInterface;
  entityPacing: EntityPacing | ComposedEntityPacing;
  headerName: string;
  includeDatesColumn?: boolean;
  includeTimeframe?: boolean;
  isTopLevel?: boolean;
  omitExpandables?: boolean;
  title: string;
};

export function EntityPacingStatus({
  currencyInfo,
  entityPacing,
  headerName,
  includeDatesColumn = false,
  includeTimeframe = false,
  isTopLevel = false,
  omitExpandables = false,
  title
}: Readonly<Props>): JSX.Element {
  return (
    <div className="entityPacingStatus" id={`${entityPacing.type}_${entityPacing.id}_pacingStatus`}>
      <div className="entityPacingStatus__header">
        <span className="entityPacingStatus__title">{title}</span>
      </div>
      <div className="entityPacingStatus__body">
        <PacingStatusTable
          currencyInfo={currencyInfo}
          entityPacing={entityPacing}
          headerName={headerName}
          includeDatesColumn={includeDatesColumn}
          includeTimeframe={includeTimeframe}
          isTopLevel={isTopLevel}
          omitExpandables={omitExpandables}
        />
      </div>
    </div>
  );
}
